import React, { useRef } from "react";
import { toast } from "react-toastify";
import CommissionHtmlTable, { CommissionHtmlTableRefProps } from "./CommissionHtmlTable";


type Props = {
    vpId: number
}
const CommissionHtmlTableButton = (props: Props) => {

    const { vpId } = props;
    const installmentHtmlTableRef = useRef<CommissionHtmlTableRefProps>(null);


    const showInstallmentHtmlTable = () => {

        if (vpId > 0) {
            installmentHtmlTableRef.current?.openModal(vpId);
        } else {
            toast.error("Lütfen tutar giriniz.");
        }

    }


    return (
        <div>
            <CommissionHtmlTable vpId={vpId} ref={installmentHtmlTableRef} />

            <div onClick={showInstallmentHtmlTable}
                className=" w-full cursor-pointer text-center text-blue-700 text-[13px] font-medium  underline mt-6">Banka Komisyon Oranlarını Görüntüle</div>
        </div>
    );
}
export default CommissionHtmlTableButton;